import { useEffect, useRef } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router';
import { useAuth } from "@workos-inc/authkit-react";

import { BRAND } from '../../shared/theme/paletteDark';
import { HOME, returnToFrom } from './returnTo';

export default function LoginRedirectPage() {
  const { signIn, isLoading, user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  /** StrictMode runs effects twice; two sign-ins race for one code verifier. */
  const started = useRef(false);

  useEffect(() => {
    // signIn();
    // Until AuthKit is up, `signIn` is a stand-in that does nothing.
    if (isLoading || started.current) return;
    started.current = true;
    // Round-trips where the user started, so they come back to it.
    const returnTo = returnToFrom(location.state) ?? HOME;
    if (user) navigate(returnTo.path, { replace: true, state: returnTo.arrival ?? null });
    else void signIn({ state: { returnTo } });
  }, [signIn, isLoading, user, location.state, navigate]);

  return (
    <Box sx={{ flex: 1, display: 'grid', placeItems: 'center' }}>
      <CircularProgress sx={{ color: BRAND.parchment }} />
      <Typography variant="body1" sx={{ fontSize: 15, color: BRAND.parchment }}>Redirecting...</Typography>
    </Box>
  );
}
